"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFailedError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * When the system makes a request that fails. This error will surface to the user
 * as a unknown error as the user may not even be aware that the system is making this request
 *
 * If the user needs to know the details of what went wrong consider using InvalidRequestError
 */
class RequestFailedError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.REQUEST_FAILED, RequestFailedError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.SERVER_ERROR, errorArgs?.userMessage || error_codes_1.ErrorMessage.SOMETHING_WENT_WRONG, originalError, errorArgs);
    }
}
exports.RequestFailedError = RequestFailedError;
